import React from "react";
import { Link } from "react-router-dom";
import { Wrench, Lock } from "lucide-react";

// Full-screen "site is down" page shown to every non-admin visitor while
// Maintenance Mode is ON. Rendered WITHOUT the normal navbar/footer.
export default function Maintenance({ message }) {
  return (
    <div
      className="min-h-screen bg-[var(--ff-bg,#0a0a0a)] text-white flex items-center justify-center px-6 relative overflow-hidden"
      data-testid="maintenance-page"
    >
      {/* ambient grain / glow */}
      <div className="pointer-events-none absolute -top-32 -left-32 w-[420px] h-[420px] rounded-full bg-[var(--ff-red)]/10 blur-[120px]" />
      <div className="pointer-events-none absolute -bottom-40 -right-24 w-[520px] h-[520px] rounded-full bg-[var(--ff-red)]/5 blur-[140px]" />

      <div className="relative max-w-2xl w-full">
        <div className="label-eyebrow text-[var(--ff-red)] mb-6 flex items-center gap-3">
          <span className="inline-block w-2 h-2 rounded-full bg-[var(--ff-red)] animate-pulse" />
          FRESHY FRESH PRODUCTIONS LLC
        </div>

        <div className="flex items-start gap-5 mb-8">
          <div className="shrink-0 w-16 h-16 border border-[var(--ff-red)]/40 bg-[var(--ff-red)]/10 flex items-center justify-center">
            <Wrench size={30} className="text-[var(--ff-red)]" />
          </div>
          <div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-none mb-3">
              Under<br />Maintenance.
            </h1>
          </div>
        </div>

        <div
          className="border-l-2 border-[var(--ff-red)] pl-5 py-1 mb-10"
          data-testid="maintenance-message"
        >
          <p className="text-[var(--ff-text-dim,#9a9a9a)] text-base leading-relaxed max-w-xl">
            {message && message.trim()
              ? message
              : "We're performing scheduled maintenance and upgrades. The site will be back online shortly — thanks for your patience."}
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-4 font-mono-ui text-xs uppercase tracking-[0.18em] text-[var(--ff-text-dim,#9a9a9a)]">
          <span>We'll be right back</span>
          <span className="w-8 h-px bg-[var(--ff-border,#2a2a2a)]" />
          <Link
            to="/login"
            className="flex items-center gap-2 text-white hover:text-[var(--ff-red)] transition-colors"
            data-testid="maintenance-admin-login-link"
          >
            <Lock size={12} /> Admin Sign In
          </Link>
        </div>
      </div>
    </div>
  );
}
